import React from "react";
import { Modal } from "react-bootstrap";
import { ActionButton } from "../../ActionBar";
import { DetailsItem } from "../../Details";
import ProductCodeDetailsTable from "./ProductCodeDetailsTable";

type Props = {
  productCode: string;
  productCodeExtended?: string;
  productVariantId: number;
};

function ProductCodeDetails({
  productCode,
  productCodeExtended,
  productVariantId,
}: Props) {
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const modal = (
    <Modal
      id="product-code-details-modal"
      show={isModalOpen}
      onHide={() => setIsModalOpen(false)}
      restoreFocus={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Product Code Details</Modal.Title>
      </Modal.Header>
      <label className="product-code">{productCode}</label>
      <Modal.Body>
        {productCodeExtended && (
          <DetailsItem
            translationKey="label.product_code_extended"
            value={productCodeExtended}
          />
        )}
        <DetailsItem translationKey="label.details">
          <div>
            <ProductCodeDetailsTable productVariantId={productVariantId} />
          </div>
        </DetailsItem>
      </Modal.Body>
    </Modal>
  );

  return (
    <>
      <ActionButton
        defaultLabel=""
        icon="icon3-eh-check-device-details"
        onClick={() => setIsModalOpen(true)}
      />
      {modal}
    </>
  );
}

export default ProductCodeDetails;
